'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

const useLoadingCursor = (loading) => {
    React.useEffect(() => {
        document.body.style.cursor = loading ? 'progress' : 'auto';
    }, [loading]);
};

exports["default"] = useLoadingCursor;
